import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/redesign-temp/girl-s2-p2.jpg")